import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Star, ArrowRight } from "lucide-react";
import { useStars } from "@/lib/useStars";
import { catMeta } from "@/lib/catalysts";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "Date TBD");
const daysUntil = (d) => {
  if (!d) return "TBD";
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const n = Math.round((new Date(d) - today) / 86400000);
  return n <= 0 ? "Today" : n === 1 ? "Tomorrow" : `in ${n}d`;
};

export default function ComingUpWidget() {
  const { starredEvents, loaded } = useStars();
  const items = starredEvents.slice(0, 5);
  return (
    <Card className="bg-[#111723] border-[#222F43] p-5 sm:p-6" data-testid="coming-up-widget">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xs font-mono uppercase tracking-[0.2em] text-slate-400 flex items-center gap-2"><Star className="h-4 w-4 text-amber-400" fill="currentColor" /> Coming Up</h3>
        <Link to="/catalysts" className="text-[11px] text-cyan-400 hover:underline flex items-center gap-1" data-testid="coming-up-all-link">All catalysts <ArrowRight className="h-3 w-3" /></Link>
      </div>
      {loaded && items.length === 0 && (
        <p className="text-slate-500 text-sm py-6 text-center" data-testid="coming-up-empty">
          No starred catalysts. <Link to="/catalysts" className="text-amber-400 hover:underline">Star events</Link> to build your feed.
        </p>
      )}
      <div className="space-y-2">
        {items.map((e) => {
          const cm = catMeta(e.category);
          return (
            <div key={e.id} className="flex items-center gap-3 rounded-lg bg-[#0c111b] border border-[#222F43] px-3 py-2" data-testid={`coming-up-${e.id}`}>
              <span className="h-8 w-1 rounded-full shrink-0" style={{ background: cm.color }} />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold truncate">{e.title}</div>
                <div className="text-[11px] text-slate-500 font-mono flex items-center gap-2">
                  {fmt(e.date)}
                  {(e.coins || []).slice(0, 3).map((c) => <span key={c} className="text-emerald-400">${c}</span>)}
                </div>
              </div>
              <span className="text-[10px] font-mono uppercase text-amber-300 shrink-0">{daysUntil(e.date)}</span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
